import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../../i18n';
import { useHeroCtaHidden } from './useHeroCtaHidden';

export const HERO_CTA_ID = 'mk-hero-cta';

// Mobile : « Commencer gratuitement » fixé en bas, seulement une fois le
// bouton du haut de page sorti de l'écran.
const FixedCta: React.FC = () => {
  const t = useT();
  const visible = useHeroCtaHidden(HERO_CTA_ID);
  return (
    <Link
      to="/signup"
      className={`mkt-btn primary mk-fixed-cta${visible ? ' is-visible' : ''}`}
      aria-hidden={!visible}
      tabIndex={visible ? undefined : -1}
    >
      {t('Commencer gratuitement')}
    </Link>
  );
};

export default FixedCta;
